import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import { Inline } from '@machobear/design-system'
import { breakpoints, fontWeights } from '@/styles'
import { IdVerificationButton } from '@/features/Persona'
import { Label } from '@/components/form'
import ProfileRequired from '@/components/profile-required'
import VerifiedBadge from '@/components/verified-badge'
import { PanelHeader, PanelTitle, StyledPanel, RequiredText } from '../elements'

const Bold = styled.span`
  font-weight: ${fontWeights.medium};
  margin-left: 3px;
`

const StyledLabel = styled(Label)`
  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 12px;
  }
`

const VerifyIdentity = ({ showRequiredWarning = false }) => {
  const { t } = useTranslation()

  return (
    <div>
      <PanelHeader>
        <PanelTitle>
          {t('r.profile.edit.verify_identity.subtitle', 'Verify Your Identity')}
          <ProfileRequired fields={['identity_verified_state']} area="liv_score" />
        </PanelTitle>
      </PanelHeader>
      {showRequiredWarning && (
        <RequiredText>{t('r.profile.view.required.label', '*Required')}</RequiredText>
      )}
      <StyledPanel hSpace={30} vSpace={30}>
        <StyledLabel>
          <Trans i18nKey="b.profile.edit.verify_id.description">
            Become <Bold>Verified</Bold>
            <VerifiedBadge type="id" verified width={28} height={24} right={3} bottom={-5} />
            by providing a government-issued photo ID. Rest assured that your ID will never be
            shared with other people on liv.rent.
          </Trans>
        </StyledLabel>
        <Inline align="right">
          <IdVerificationButton />
        </Inline>
      </StyledPanel>
    </div>
  )
}

export default VerifyIdentity
